export const omsInitEnvConfig = {
  TOKEN_NAME: "_iam_token",
  IAM_HOST: "http://localhost:8001",
  PARTNER_HOST: "http://localhost:3000/",
  ERP_API_HOST: "/",
  OMS_HOST: "http://localhost:8001/"
};
